import React from 'react'
import AdvertisementsBannerList from '../Advertisements/AdvertisementsBannerList'
import Slider from 'react-slick'
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows'
import AdvertisementItem from '../Advertisements/AdvertisementItem'
import getAdvertisementImgKeyArray from '../functions/getAdvertisementImgKeyArray'
import AdvertisementImage from '../Advertisements/AdvertisementImage'

const AdvertisementsBannerImages = ({images, imageURLs, imgTag }) => {
    const imgKeyArray = getAdvertisementImgKeyArray(imageURLs, images)

    return (
        <div className="custom-placement-image-container">
            {imgKeyArray.map(key => imageURLs[key] && <AdvertisementImage
                key={key}
                imgKey={key}
                imgURL={imageURLs[key]}
                imgTag={imgTag || 'mobile' === key}
            />)}
        </div>
    )
}

const SliderAdvertisements = ({  
    theme,
    items,
    advertisements,
    selectionId,
    isMobile,
    translation,
    scrollToPosition
}) => {   

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        focusOnSelect: true,
        swipeToSlide: true,
        nextArrow: <SliderArrowNext />,
        prevArrow: <SliderArrowPrev />
    }

    let itemsLength = items.length
    let maxThreeItems = items

    if(3 < itemsLength) {
        itemsLength = 3
        maxThreeItems = items.slice(0, 3)
    }

    const imageKeys = [
        'desktopOne',
        'desktopTwo',
        'desktopThree'
    ]

    const itemOrigin = "Home Banner"
    const imageURLs = {
        [imageKeys[itemsLength - 1]]: false,
        mobile: false
    }
 
    return ( isMobile ? (
        <Slider className={scrollToPosition} {...settings}>
            {maxThreeItems.map(item => (
                <div key={item.pk} className='custom-placements-banner-list items-1'>
                    <AdvertisementItem
                        item={item}
                        itemOrigin={itemOrigin}
                    >
                        <AdvertisementsBannerImages
                            images={item.images} 
                            imageURLs={{ ...imageURLs}}
                            imgTag={1 === itemsLength}
                        />
                    </AdvertisementItem>    
                </div>
            ))}
        </Slider>
    ) : (
        <div className={scrollToPosition}>
            <AdvertisementsBannerList 
                homeOrigin={true}
                items={items} 
            />
        </div>
    )
    )
}

export default SliderAdvertisements